export default __webpack_public_path__ + "static/media/full3.a033cbf9.jpg";